import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as routingUtil from 'common/routing/routes.js';
import UserPreferences from 'common/sessionStore/userPreferences.js';
import { ajaxActions } from 'common/ajax/store.js';
import { settingActions } from 'common/setting/store.js';
import { routes, getRouteName } from 'common/routing/routes.js';
import Layout from './Layout.js';

class LayoutContainer extends React.Component {
  state = {};

  constructor(props) {
    super(props);
    this.userPreferences = new UserPreferences();
    const routes = routingUtil.getRoutesForMenu(routingUtil.routes, 'main');
    const profileRoutes = routingUtil.getRoutesForMenu(
      routingUtil.routes,
      'profile'
    );

    this.state = { routes: routes, profileRoutes: profileRoutes };
  }

  componentDidMount = () => {
    const { match } = this.props;
    const { adfitNo } = match.params;

    if (adfitNo) {
      this.getSettings(adfitNo);
    }
  };

  componentWillUnmount = () => {
    this.props.resetAjaxStatus();
  };

  handleTabChange = (item) => {
    const { history, adfitNo, match } = this.props;
    const route = this.state.routes.find((o) => o.name === item);
    const path = route.path.replace(
      ':adfitNo',
      adfitNo || match.params.adfitNo
    );
    history.push(path);
  };

  handleAlertClose = () => {
    this.props.resetAjaxStatus();
  };

  getAjaxErrorMessage = () => {
    const { error } = this.props.ajaxStatus;
    const prompt = this.props.localisation.prompts;
    if (!error) return prompt.ajaxError_Generic;
    return prompt['ajaxError_' + error.status] || prompt.ajaxError_Generic;
  };

  getSettings = (adfitNo) => {
    const { getTaxInvoicesSettings } = this.props;
    if (this.shouldReloadData()) {
      getTaxInvoicesSettings(adfitNo);
    }
  };

  shouldReloadData = () => {
    const { match, adfitNo } = this.props;
    return adfitNo !== match.params.adfitNo;
  };

  filterRoutesBySettings = (routes, { isTaxInvoiceEnabled }) => {
    const filteredRoutes = [...routes];
    //Filter out Invoices tab if the feature flag is off
    if (!isTaxInvoiceEnabled) {
      const taxInvoicesRoute = filteredRoutes.find(
        (x) => x.name === 'Invoices'
      );
      if (taxInvoicesRoute) {
        filteredRoutes.splice(filteredRoutes.indexOf(taxInvoicesRoute), 1);
      }
    }
    return filteredRoutes;
  };

  render() {
    const {
      userId,
      ajaxStatus,
      location,
      profileName,
      localisation,
      hideMenu,
      match,
      adfitNo,
      isTaxInvoiceEnabled,
    } = this.props;
    const currentPath = location.pathname;
    const currentPathName = getRouteName(routes, location.pathname);
    const accessDenied =
      ajaxStatus.error != null && ajaxStatus.error.status === 401;
    const showAjaxErrorAlert =
      ajaxStatus.error != null &&
      ajaxStatus.error.status !== 400 &&
      ajaxStatus.error.status !== 401 &&
      ajaxStatus.isEditAction !== true; //don't show alert if it's validation error (Bad Request)
    const alert = {
      showAlert: showAjaxErrorAlert,
      title: localisation.prompts.ajaxErrorTitle,
      text: this.getAjaxErrorMessage(),
      redirectUrl: '/LogOut',
      buttonText: 'Sign Out',
    };
    const tabIndex = this.state.routes.findIndex((i) => i.path === match.path);
    const hasAcceptedTC =
      this.props.hasAcceptedTC || this.userPreferences.getTcAccepted(userId);
    const topBarOpen = hasAcceptedTC;
    const showTabs =
      (adfitNo || match.params.adfitNo) && hasAcceptedTC && !hideMenu;
    const tabRoutes = this.filterRoutesBySettings(this.state.routes, {
      isTaxInvoiceEnabled,
    });

    return (
      <Layout
        routes={tabRoutes}
        open={hasAcceptedTC}
        topBarOpen={topBarOpen}
        showTabMenu={showTabs}
        accessDenied={accessDenied}
        profileRoutes={this.state.profileRoutes}
        alert={alert}
        location={location}
        currentPath={currentPath}
        currentPathName={currentPathName}
        handleAlertClose={this.handleAlertClose}
        ajaxIsLoading={ajaxStatus.isLoading}
        showSpinner={ajaxStatus.showSpinner}
        profileName={profileName}
        handleTabChange={this.handleTabChange}
        selectedTab={tabIndex}>
        {this.props.children}
      </Layout>
    );
  }
}

LayoutContainer.propTypes = {
  permisisions: PropTypes.array,
};

const mapStatetoProps = (state) => {
  return {
    permissions: state.auth.permissions,
    hasAcceptedTC: state.auth.hasAcceptedTC,
    userId: state.auth.userId,
    ajaxStatus: state.ajax,
    profileName: state.auth.fullName,
    localisation: state.localisation,
    adfitNo: state.customerDetails.adfitNo,
    isTaxInvoiceEnabled: state.settings.isTaxInvoiceEnabled,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetAjaxStatus: () => {
      dispatch(ajaxActions.resetAjaxStatus());
    },
    getTaxInvoicesSettings: (adfitNo) => {
      dispatch(settingActions.getTaxInvoicesSettings(adfitNo));
    },
  };
};

export default withRouter(
  connect(mapStatetoProps, mapDispatchToProps)(LayoutContainer)
);
